import { render } from "./WatermarkTab.vue?vue&type=template&id=23396a97"
import script from "./WatermarkTab.vue?vue&type=script&lang=js"
export * from "./WatermarkTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__